require('./RAAccordion.scss');
const PropTypes = require('prop-types');
const React = require('react');

class RAAccordion extends React.Component {
    render() {
        return <div className="ra-accordion">{this.props.children}</div>;
    }
}

RAAccordion.propTypes = {
    id: PropTypes.string,
    children: PropTypes.array,
};

module.exports = RAAccordion;
